<template>
    <div class="container main" v-if="itemLoaded">
        <a name="top"></a>
        <div class="containerz main" v-if="hasItem">
            <div class="row">
                <div class="twelve columns">
                    <h6 style="margin-bottom: 15px;"><a :href="baseURL">&lt; Back to {{ backLabel }} list</a> </h6>
                    <h1 class="h4">{{ item.WebsiteTitle }}</h1>
                </div>
            </div>
            <div class="row">
                <div class="one-half column gallery-wrapper" style="min-height: 1px;">
                    <div class="youtube" v-if="item && item.YouTubeID.length > 0">
                        <iframe class="video" :src="`https://www.youtube.com/embed/${item.YouTubeID}?autoplay=1&loop=1`" frameborder="0" allowfullscreen></iframe>
                    </div>
                    <div class="gallery-container" v-if="hasGallery" style="position: relative;padding: 5px;">
                        <GalleryCarousel :gallery="gallery" :equipment="`${ item.WebsiteTitle }`" />
                        <div class="ribbon" v-if="item.StatusID == 6"><span>SOLD</span></div>
                        <div class="ribbon-yellow" v-if="item.StatusID == 8"><span>UNDER OFFER</span></div>
                        <div class="ribbon-green" v-if="item.StatusID == 10"><span>COMING SOON</span></div>
                        <div class="ribbon-blue" v-if="item.AuctionLink"><span>AUCTION</span></div>
                    </div>
                </div>
                <div class="one-half column some-paddingz">
                    <b>Key Information</b>
                    <table class="equipment-information">
                        <colgroup>
                           <col span="1" style="width: 140px;">
                        </colgroup>
                        <tbody>
                            <tr v-if="item && item.AssetNumber">
                                <th>Asset Number:</th>
                                <td>{{ item.AssetNumber }}</td>
                            </tr>
                            <tr v-if="item && item.Make">
                                <th>Make:</th>
                                <td>{{ item.Make }}</td>
                            </tr>
                            <tr v-if="item && item.Model">
                                <th>Model:</th>
                                <td>{{ item.Model }}</td>
                            </tr>
                            <tr v-if="item && item.YOM">
                                <th title="Year of Manufacture">YOM:</th>
                                <td>{{ item.YOM }}</td>
                            </tr>
                            <tr v-if="item && item.SerialNumber">
                                <th>Serial Number:</th>
                                <td>{{ item.SerialNumber }}</td>
                            </tr>
                            <tr v-if="item && item.RegistrationNumber">
                                <th>Registration Number:</th>
                                <td>{{ item.RegistrationNumber }}</td>
                            </tr>
                            <tr v-if="item && item.RegistrationExpiryDate">
                                <th>Registration Expiry:</th>
                                <td>{{ item.RegistrationExpiryDate }}</td>
                            </tr>
                            <tr v-if="item && item.SMU">
                                <th>Frame Hours:</th>
                                <td>{{ item.SMU }}</td>
                            </tr>
                            <tr v-if="item && item.Mileage">
                                <th>Odometer:</th>
                                <td>{{ item.Mileage }}</td>
                            </tr>
                            <tr v-if="item && item.LoadingDetails">
                                <th>Loading Details:</th>
                                <td>{{ item.LoadingDetails }}</td>
                            </tr>
                            <tr v-if="item && item.Country">
                                <th>Country:</th>
                                <td>{{ item.Country }}</td>
                            </tr>
                            <tr v-if="item && item.State">
                                <th>State:</th>
                                <td>{{ item.State }}</td>
                            </tr>
                        </tbody>
                    </table>
                    <p v-html="item.FullDescription"></p>
                    <p>
                        <b>
                            <span v-if="equipment"><a href="#" style="color: #c41130" v-on:click.prevent="downloadFlyer(equipment)">Download Flyer</a> &nbsp;&nbsp;</span>
                            <span v-if="item && item.AuctionLink"><a :href="`${ item.AuctionLink }`" style="color: #c41130" target="_blank">View Auction</a></span>
                        </b>
                    </p>
                    <p v-if="!formSent">
                        <b>Interested in this equipment?</b><br>
                        Please use this form to contact us. Fill in all fields.
                    </p>
                    <form method="post" action="https://www.assetdatamanager.com/adm/web/enquiry.aspx" id="ctl00" v-if="!formSent">
                        <div class="aspNetHidden">
                            <input type="hidden" name="__VIEWSTATE" id="__VIEWSTATE" value="QbEMwudaMiDcPTz1+AqDJE1Aa7aM0yx/I2zjwILBdYVKYsywCzsP+cqhlUA/BkWJ0AuZgOV3UWW+xj7UM0ucpv3EeQQEszRyF2eOEzHskCDMQehKB5LGFhdXr2d7b7nMR3or2HsA0Zu70VJKXNcWkg==">
                        </div>
                        <div class="aspNetHidden">
                           <input type="hidden" name="__VIEWSTATEGENERATOR" id="__VIEWSTATEGENERATOR" value="6AADB5B2">
                        </div>
                        <div class="row">
                            <div class="six columns">
                                <label>Your Name</label>
                                <input type="text" id="Name" name="Name" class="u-full-width" placeholder="John Smith" required="">
                            </div>
                            <div class="six columns">
                                <label>Your email</label>
                                <input type="text" id="Email" name="Email" class="u-full-width" placeholder="me@my.com" required="">
                            </div>
                        </div>
                        <div class="row">
                            <div class="six columns">
                                <label>Your phone number</label>
                                <input type="text" id="Phone" name="Phone" class="u-full-width" placeholder="" required="">
                            </div>
                        </div>
                        <input type="hidden" id="Subject" name="Subject" :value="`${formSubject}`">
                        <input type="hidden" id="ItemType" name="ItemType" value="For Sale">
                        <input type="hidden" name="To" :value="`${curEmail}`">
                        <input type="hidden" name="thankyou" :value="`${returnURL}&sent=1`">
                        <input type="hidden" name="redirecturl" :value="`${returnURL}&sent=1`">
                        <label for="Message">Message</label>
                        <textarea id="Message" name="Message" class="u-full-width" placeholder="I am interested in …" textmode="MultiLine" style="height: 100px"></textarea>
                        <input type="submit" id="SendMessage" class="button-primary" value="Send">
                    </form>
                    <p v-if="formSent" style="color: rgb(196, 17, 48);font-weight: 700;">Your enquiry has been sent. We will get back to you.</p>
                    <p>
                        <b>{{ curCompany }}</b><br>
                        Telephone: {{ curTel }}<br>
                        Web: {{ curURL }}
                    </p>
                </div>
            </div>
        </div>
        <div class="containerz main" v-if="!hasItem">
            <div class="row">
                <div class="twelve columns">
                    <h6 style="margin-bottom: 15px;"><a :href="baseURL">&lt; Back to {{ backLabel }} list</a> </h6>
                    <h1 class="h4">Invalid equipment ID</h1>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import GalleryCarousel from './GalleryCarousel.vue'

export default {
    name: 'Equipment',
    components: { 
        GalleryCarousel
    },
    props: [
        'data',
        'source',
        'equipment',
        'type'
    ],
    data() {
        return {
            itemLoaded: false,
            returnURL: window.location.href,
            baseURL: '',
            formSubject: '',
            item: false,
            gallery: [],
            hasItem: false,
            hasGallery: false,
            refresh: 0,
            formSent: false,
            curCompany: '',
            curEmail: '',
            curURL: '',
            curTel: '',
            backLabel: ''
        };
    },
    mounted() {
        this.init();
    },
    methods: {
        async init () {
            this.backLabel = this.type == 'wanted' ? 'Wanted' : 'For Sale';
            this.backLabel = this.type == 'forhire' ? 'For Hire' : this.backLabel;

            let urlParams = new URLSearchParams(window.location.search);
            urlParams.delete('equipment');

            this.formSent = urlParams.get('sent');

            let additionalParam = '';
            additionalParam += (urlParams.get('co')) ? '&co=' + urlParams.get('co') : '';
            additionalParam += (urlParams.get('ca')) ? '&ca=' + urlParams.get('ca') : '';
          
            let params = urlParams.toString();
            this.baseURL = window.location.pathname + ((params) ? '?' + params : '');

            const item = await fetch(this.source + '/web/item-json.aspx?i=' + this.equipment + '&c=' + this.data + additionalParam);
            let arrItem = await item.json();
            if ( arrItem.Item.length ) {
                this.item = arrItem.Item[0];

                if ( this.item.RegistrationExpiryDate ) {
                    let objectDate = new Date(this.item.RegistrationExpiryDate);
                    let day = objectDate.getDate();
                    let month = objectDate.getMonth();
                    let year = objectDate.getFullYear();

                    if ( parseInt(year) > 2000 ) {
                        day = (day < 10) ? '0' + day : day;
                        month = (month < 10) ? `0${month}` : month;

                        this.item.RegistrationExpiryDate = `${day}/${month}/${year}`;
                    }
                    else {
                        this.item.RegistrationExpiryDate = '';
                    }
                }
                else {
                    this.item.RegistrationExpiryDate = '';
                }
                
                this.hasItem = true;
                this.itemLoaded = true;

                this.formSubject += (arrItem.Item[0] && arrItem.Item[0].AssetNumber) ? arrItem.Item[0].AssetNumber + ': ' : '';
                this.formSubject += (arrItem.Item[0] && arrItem.Item[0].WebsiteTitle) ? arrItem.Item[0].WebsiteTitle : '';                
                
                if ( arrItem.Item[0].WebsiteTitle )
                    document.title = arrItem.Item[0].WebsiteTitle;

                this.loadGallery(1);
                this.loadCompanyDetails();
            }
            else {
                this.hasItem = false;
                this.itemLoaded = true;
            }
        },
        async loadCompanyDetails() {
            var dataURL = window.location.origin;
            let companyInfo = await fetch(this.source + '/web/company-json.aspx?c=' + this.data).catch((error) => {console.log(error)});
            if ( !companyInfo.ok ) {
                this.curURL = '';
                this.curCompany = '';
                this.curEmail = '';
                this.curTel = '';
            }
            else {
                let arrCompanyInfo = await companyInfo.json();
                if ( arrCompanyInfo ) {
                    this.curURL = arrCompanyInfo.Company[0].Website;
                    this.curCompany = arrCompanyInfo.Company[0].Company;
                    this.curEmail = arrCompanyInfo.Company[0].Email;
                    this.curTel = arrCompanyInfo.Company[0].Telephone;
                }
                else {
                    this.curURL = dataURL;
                    this.curCompany = 'ADM Sample Company';
                    this.curEmail = 'davidblake@admsamplecompany.net';
                    this.curTel = '08 9 466 3474';
                }

                let tmpURL = new URL(this.curURL);
                this.curURL = tmpURL.host;
            }
        },
        async loadGallery(counter) {
            if ( parseInt(counter) <= 5 ) {
                const _self = this;
                const gallery = await fetch(_self.source + '/web/gallery-json.aspx?u=true&i=' + _self.equipment + '&c=' + _self.data + '&_time=' + Math.floor(Date.now() / 1000));
                let jsonText = await gallery.text();
                try{
                    let arrGallery = JSON.parse(jsonText);
                    let galleryData = [];
                    let allRows = arrGallery.map(function(d) {
                        galleryData.push({
                            url: d.url,
                            src: d.url,
                            thumbSrc: d.url,
                            w: 1600,
                            h: 1068
                        });
                    });

                    Promise.all(allRows).then(() => {
                        _self.gallery = galleryData;
                        _self.hasGallery = true;
                    });
                } catch(err) {
                    _self.loadGallery(counter+1);
                }
            }
        },
        async downloadFlyer (equipment) {
            let url = this.source + '/ForSaleFlyer.aspx?c=' + this.data + '&id=' + equipment;
            await fetch(url)
            .then(response => response.blob())
            .then(blob  => {
                var url = window.URL.createObjectURL(blob);
                var a = document.createElement('a');
                a.href = url;
                a.download = 'flyer-'+equipment+'.pdf';
                document.body.appendChild(a);
                a.click();    
                a.remove(); 
            }).catch(console.error);
        }
    }
}
</script>
